import React, { useState } from 'react';
import { Activity, Lock, User } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleLogin = (e) => {
    e.preventDefault();
    setError('');
    const loginSuccess = login({ username, password });
    if (loginSuccess) {
      navigate('/dashboard');
    } else {
      setError('Credenciales incorrectas. Intente de nuevo.');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-4xl flex bg-white rounded-2xl shadow-2xl overflow-hidden">
        {/* Columna Izquierda - Imagen */}
        <div className="hidden md:block w-1/2 bg-cover bg-center" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1584972130321-4f3684849b89?auto=format&fit=crop&w=687&q=80')" }}>
          <div className="h-full w-full bg-blue-600 bg-opacity-50"></div>
        </div>

        {/* Columna Derecha - Formulario */}
        <div className="w-full md:w-1/2 p-8 sm:p-12">
          <div className="flex items-center mb-6">
            <Activity className="h-8 w-8 text-blue-600" />
            <span className="ml-2 text-2xl font-bold text-gray-900">
              Tu<span className="text-blue-600">HIS</span>
            </span>
          </div>
          <h2 className="text-3xl font-bold text-gray-800 mb-2">Bienvenido de Nuevo</h2>
          <p className="text-gray-500 mb-8">Accede al portal médico.</p>

          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4" role="alert">
              <span className="block sm:inline">{error}</span>
            </div>
          )}

          <form onSubmit={handleLogin}>
            <div className="mb-5 relative">
              <User className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
              <input
                type="text"
                placeholder="ID de Usuario o Email"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div className="mb-5 relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
              <input
                type="password"
                placeholder="Contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div className="flex items-center justify-between mb-8">
              <Link to="/recuperar-password" className="text-sm text-blue-600 hover:underline">¿Olvidaste tu contraseña?</Link>
            </div>

            <button
              type="submit"
              className="w-full bg-gradient-to-r from-blue-600 to-blue-500 text-white py-3 rounded-lg font-semibold text-lg hover:from-blue-700 hover:to-blue-600 transition-all duration-300 shadow-md hover:shadow-lg"
            >
              Iniciar Sesión
            </button>
          </form>
          <p className="text-center text-sm text-gray-500 mt-8">
            ¿No tienes una cuenta? <Link to="/" className="text-blue-600 font-medium hover:underline">Regresar al inicio</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;